import { render, staticRenderFns } from "./Product1Detail.vue?vue&type=template&id=84ea4894&scoped=true"
import script from "./Product1Detail.vue?vue&type=script&lang=js"
export * from "./Product1Detail.vue?vue&type=script&lang=js"
import style0 from "./Product1Detail.vue?vue&type=style&index=0&id=84ea4894&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84ea4894",
  null
  
)

export default component.exports